import { render, staticRenderFns } from "./welcomeLeftLink.vue?vue&type=template&id=67e0514c&scoped=true"
import script from "./welcomeLeftLink.vue?vue&type=script&lang=js"
export * from "./welcomeLeftLink.vue?vue&type=script&lang=js"
import style0 from "./welcomeLeftLink.vue?vue&type=style&index=0&id=67e0514c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0514c",
  null
  
)

export default component.exports